<mat-card>
    <div class="application">
        <a [routerLink]="['.', 'application', 'id', application.id]">{{application.label || application.id}}</a>
    </div>
</mat-card>
